import Image from '@/components/ImgproxyImage'

interface ParallaxImageProps {
  src: string
  alt: string
  className?: string
}

export default function ParallaxImage({ src, alt, className = '' }: ParallaxImageProps) {
  return (
    <div className="relative h-full w-full">
      <Image
        src={src}
        alt={alt}
        className={`h-full w-full object-cover ${className} scale-105`}
        width={1000}
        height={1000}
      />
    </div>
  )
}
